module.exports = __webpack_public_path__ + "img/signup-group-1.82ddfa03.png";